
import { NonFatalErrorCommand } from "slotworks/commands/error/non-fatal-error-command";
import Contract from "../../utils/contract";
import gameLoop from "slotworks/core/game-loop";

export function FatalErrorCommand(messageId: string , sceneNames: string[] = ["criterror"], button?: any[], data?: any) {

    NonFatalErrorCommand(messageId, sceneNames, button, data).then(() => {
        location.reload();
    });
    gameLoop.setPaused(true);
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/error/fatal-error-command.ts